const BASE = process.env.REACT_APP_API_URL || 'https://0g75gzq525.execute-api.us-east-1.amazonaws.com';

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('cf_token');
  return token ? { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
               : { 'Content-Type': 'application/json' };
}

async function request<T>(method: string, path: string, body?: any): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: authHeaders(),
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || data.message || `API ${res.status}`);
  return data;
}

// ── Auth ────────────────────────────────────────────────────────
export const authApi = {
  requestOtp: (email: string, fullName: string, mobile: string) =>
    request<any>('POST', '/auth/request-otp', { email, fullName, mobile }),
  verifyOtp: (email: string, otp: string) =>
    request<any>('POST', '/auth/verify-otp', { email, otp }),
  me: () => request<any>('GET', '/me'),
};

// ── Twin / Workspace ────────────────────────────────────────────
export const twinApi = {
  create: (payload: { company: string; factoryType: string; machines: any[]; sensors: string[] }) =>
    request<any>('POST', '/twin/create', { ...payload, dataSource: 'IoTCore' }),
  listWorkspaces: () =>
    request<any[]>('GET', '/workspaces'),
  getWorkspace: (wsId: string) =>
    request<any>('GET', `/workspaces/${wsId}`),
  updateWorkspace: (wsId: string, data: any) =>
    request<any>('PUT', `/workspaces/${wsId}`, data),
  deleteWorkspace: (wsId: string) =>
    request<any>('DELETE', `/workspaces/${wsId}`),
};

// ── Telemetry ───────────────────────────────────────────────────
export const telemetryApi = {
  ingest: (wsId: string, machineId: string, sensors: { sensorId: string; type: string; value: number; unit: string }[]) =>
    request<any>('POST', `/workspaces/${wsId}/telemetry`, { workspaceId: wsId, machineId, sensors, timestamp: new Date().toISOString() }),
  latest: (wsId: string) =>
    request<any>('GET', `/workspaces/${wsId}/telemetry/latest`),
  history: (wsId: string, machineId: string, sensorId: string, limit?: number) =>
    request<any>('GET', `/workspaces/${wsId}/telemetry/history?machineId=${machineId}&sensorId=${sensorId}&limit=${limit || 50}`),
};

// ── Alerts ──────────────────────────────────────────────────────
export const alertsApi = {
  list: (wsId: string, severity?: string) =>
    request<any>('GET', `/workspaces/${wsId}/alerts${severity ? `?severity=${severity}` : ''}`),
  create: (wsId: string, alert: {
    machineId: string; machineName: string;
    sensorId: string; sensorName: string;
    severity: string; value: number; threshold: number; message: string;
  }) =>
    request<any>('POST', `/workspaces/${wsId}/alerts`, alert),
  ack: (wsId: string, alertId: string) =>
    request<any>('POST', `/workspaces/${wsId}/alerts/${encodeURIComponent(alertId)}/ack`),
};
